import { AnyAction } from 'redux';
import { Employee } from '@synergy/models';

import {
    SUPPLIER_EMPLOYEES_ADD,
    SUPPLIER_EMPLOYEES_CHANGE_POSITION,
    SUPPLIER_EMPLOYEES_CHANGE_TAGS,
    SUPPLIER_EMPLOYEES_RECEIVED,
    SUPPLIER_EMPLOYEES_REMOVE_FAILED_WITH_BONUS_CONDITION_ERROR,
    SUPPLIER_EMPLOYEES_REMOVE_SUCCESS,
    SUPPLIER_EMPLOYEES_RESET_BONUS_CONDITION_ERROR,
    SUPPLIER_EMPLOYEES_SET_AS_IMPORT_CONTACT,
    SUPPLIER_EMPLOYEES_SET_AS_MAIN_CONTACT,
} from './supplier-employee-actions';

export interface SupplierEmployeeReducerState {
    employees: Employee[] | null;
    hasBonusConditionError: boolean;
}

export const initialSupplierEmployeeReducerState: SupplierEmployeeReducerState = {
    employees: null,
    hasBonusConditionError: false,
};

export const supplierEmployeeReducer = (
    state: SupplierEmployeeReducerState = initialSupplierEmployeeReducerState,
    action: AnyAction
): SupplierEmployeeReducerState => {
    switch (action.type) {
        case SUPPLIER_EMPLOYEES_RECEIVED: {
            return {
                ...state,
                employees: action['employees'],
            };
        }

        case SUPPLIER_EMPLOYEES_ADD: {
            return {
                ...state,
                employees: [...(state.employees ?? []), action['employee']],
            };
        }

        case SUPPLIER_EMPLOYEES_REMOVE_SUCCESS: {
            const nextEmployees = state.employees?.filter(employee => employee.id !== action['employeeId']) ?? [];
            if (action['reassignMainContactId']) {
                nextEmployees.forEach(
                    employee => (employee.isMainContact = employee.id === action['reassignMainContactId'])
                );
            }
            if (action['nextBonusContactId']) {
                nextEmployees.forEach(
                    employee => (employee.hasBonusConditions = employee.id === action['nextBonusContactId'])
                );
            }

            if (action['nextImportContactId']) {
                nextEmployees.forEach(
                    employee => (employee.isImportContact = employee.id === action['nextImportContactId'])
                );
            }

            return {
                ...state,
                employees: nextEmployees,
            };
        }

        case SUPPLIER_EMPLOYEES_SET_AS_MAIN_CONTACT: {
            return {
                ...state,
                employees: (state.employees ?? []).map(employee => ({
                    ...employee,
                    isMainContact: employee.id === action['employeeId'],
                })),
            };
        }

        case SUPPLIER_EMPLOYEES_SET_AS_IMPORT_CONTACT: {
            return {
                ...state,
                employees: (state.employees ?? []).map(employee => ({
                    ...employee,
                    isImportContact: employee.id === action['employeeId'],
                })),
            };
        }

        case SUPPLIER_EMPLOYEES_CHANGE_POSITION: {
            const nextEmployees = [...(state.employees ?? [])];
            const index = nextEmployees.findIndex(employee => employee.id === action['employeeId']);
            if (index < 0) {
                return state;
            }

            nextEmployees[index].position = action['position'];
            return {
                ...state,
                employees: nextEmployees,
            };
        }

        case SUPPLIER_EMPLOYEES_CHANGE_TAGS: {
            const nextEmployees = [...(state.employees ?? [])];
            const index = nextEmployees.findIndex(employee => employee.id === action['employeeId']);
            if (index < 0) {
                return state;
            }

            nextEmployees[index].tags = action['tags'];
            return {
                ...state,
                employees: nextEmployees,
            };
        }

        case SUPPLIER_EMPLOYEES_REMOVE_FAILED_WITH_BONUS_CONDITION_ERROR: {
            return {
                ...state,
                hasBonusConditionError: true,
            };
        }

        case SUPPLIER_EMPLOYEES_RESET_BONUS_CONDITION_ERROR: {
            return {
                ...state,
                hasBonusConditionError: false,
            };
        }

        default: {
            return state;
        }
    }
};
